import { render } from "./videoPresentation.vue?vue&type=template&id=e8ff2ef2&scoped=true"
import script from "./videoPresentation.vue?vue&type=script&lang=js"
export * from "./videoPresentation.vue?vue&type=script&lang=js"

import "./videoPresentation.vue?vue&type=style&index=0&id=e8ff2ef2&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8ff2ef2"]])

export default __exports__